import {IResolvedFeatureFlags} from "../types/IResolvedFeatureFlag";

const OFF_VARIANT = "off";

let resolvedFlags: IResolvedFeatureFlags = {};

export const setResolvedFeatureFlags = (flags: IResolvedFeatureFlags): void => {
    resolvedFlags = flags;
};

export const getResolvedFeatureFlags = (): IResolvedFeatureFlags => {
    return resolvedFlags;
};

export const isFeatureFlagEnabled = (flagId: string): boolean => {
    return (resolvedFlags[flagId]?.variant ?? OFF_VARIANT) !== OFF_VARIANT;
};

export const getFeatureFlagVariant = (flagId: string): string => {
    return resolvedFlags[flagId]?.variant ?? OFF_VARIANT;
};
